import { createAction } from "@logicsoftware/redux-toolkit";
import { normalize } from "normalizr";
import { put, select, takeLeading } from "redux-saga/effects";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { Preset } from "~/normalizr/entities";
import { presetsSchema } from "~/normalizr/PresetsSchema";
import { doReconstructEntities } from "~/Redux/Middleware/apiMiddleware";
import { callApi } from "~/Redux/Sagas/effects/callApi";
import { Space, spacesList } from "~/Redux/Spaces";

export const reloadPresets = createAction("PRESET/RELOAD_PRESETS");

export function* watchReloadPresets() {
    yield takeLeading(reloadPresets, runPresetsReloading);
}

export function* runPresetsReloading() {
    const spaces: Space[] = yield select(spacesList);

    const presets: Preset[] = yield callApi(({ ajaxOptions }) =>
        OAuthClient.postJson(appUrls.preset.getAll, { spaceIds: spaces.map(({ SpaceId }) => SpaceId) }, ajaxOptions)
    );

    const { entities } = normalize(presets, presetsSchema);
    yield put(doReconstructEntities(entities));
}
